<template>
    <div class="d-flex flex-column gap-3">
        <div>
            <ButtonComp
                button-type="Secondary"
                :icon="'fab fa-wikipedia-w'"
                :loadstate="LoadState"
                :disabled="LoadState.isActive"
                @click="loadWWikipediaInfo"
                >{{ $tm('contestant.getwikipediainfo') }}</ButtonComp
            >
        </div>

        <InputText
            placeholder="communication.errorreportmessageplaceholder"
            label="communication.errorreportmessage"
            label-position="top"
            v-model="model.Memo"
            :multiline="true"
        />
    </div>
</template>
<script lang="ts" setup>
import { ButtonComp, InputText } from '@/components';
import { useTaskLoader } from '@/composeables';
import { ContestantFavoriteDao } from '@/dao';
import { RaceContestantDetails } from '@/objects/generated';

const model = defineModel<RaceContestantDetails>({ required: true });

const { AddLoader, LoadState } = useTaskLoader();

const loadWWikipediaInfo = async () => {
    await AddLoader(async () => {
        const info = await ContestantFavoriteDao.GetWikipediaInfo(model.value.EventID, model.value.ContestantID);

        // We need to check if there is the same text in the memo allready and then remove it first
        if (model.value.Memo && info?.Ingress && model.value.Memo.includes(info.Ingress)) {
            model.value.Memo.replace(info.Ingress, '');
            model.value.Memo.replace('/// From Wikipedia ///\r\n', '');
        }

        // Add the From Wikipedia text to the memo, we also want to add some line breaks before and after to make it more readable
        if (info?.Ingress) {
            info.Ingress = '/// From Wikipedia ///\r\n' + info.Ingress;
        }

        model.value.Memo = (info?.Ingress || '').replace(/\n/g, '\n\n'); // We add one line break to make it more readable in the textarea. We also want to make sure to not set it to null if there is no info, but just an empty string.
        console.log(info);
    }, '');
};
</script>
